/**
 * Chinese translations. Missing keys fall back to the English source string,
 * so a partial dictionary never produces empty labels.
 */
export const zh: Record<string, string> = {
  Home: "首页",
  Explore: "发现",
  "Explore Relays": "发现中继",
  Notifications: "通知",
  Bookmarks: "收藏",
  Search: "搜索",
  Settings: "设置",
  Relays: "中继",
  "Relay feeds": "中继信息流",
  "Relay Feeds": "中继信息流",
  "Following": "关注",
  "Following feed": "关注信息流",
  Feed: "信息流",
  "Relay sets": "中继分组",
  "Relay set": "中继分组",
  "My relays": "我的中继",
  "Add relay": "添加中继",
  "Add to relays": "添加到中继",
  "Remove relay": "移除中继",
  "Remove from relays": "从我的中继移除",
  "New relay set": "新建中继分组",
  "Relay details": "中继详情",
  "Relay reviews": "中继评价",
  "Write a review": "撰写评价",
  "Publish review": "发布评价",
  "Supported NIPs": "支持的 NIP",
  Software: "软件",
  Description: "描述",
  "No description": "没有描述",
  "No NIP-11 metadata": "没有 NIP-11 元数据",
  "Search this relay": "搜索此中继",
  "This relay supports NIP-50 search": "此中继支持 NIP-50 搜索",
  Theme: "主题",
  Appearance: "外观",
  Light: "浅色",
  Dark: "深色",
  "Pure black": "纯黑",
  System: "跟随系统",
  Language: "语言",
  Account: "账户",
  Login: "登录",
  Logout: "退出登录",
  "Log in": "登录",
  "Log in with extension": "使用浏览器扩展登录",
  "Read only": "只读",
  "Public key": "公钥",
  "Private key": "私钥",
  "Publish a note": "发布笔记",
  Publish: "发布",
  Publishing: "发布中…",
  Reply: "回复",
  React: "点赞",
  Repost: "转发",
  Bookmark: "收藏",
  "Copy link": "复制链接",
  "Copy note id": "复制笔记 ID",
  "Copy relay address": "复制中继地址",
  "Load more": "加载更多",
  "New notes": "新笔记",
  "No notes yet": "还没有笔记",
  "No relays yet": "还没有中继",
  "No results": "没有结果",
  "Something went wrong": "出错了",
  "Try again": "重试",
  "Go back": "返回",
  "Back home": "返回首页",
  "Page not found": "页面不存在",
  "Get started": "开始使用",
  "Welcome": "欢迎",
  "Your relays": "你的中继",
  "Add relays to get started": "添加中继以开始使用",
  "Add your first relay": "添加你的第一个中继",
  "Read-only session": "只读会话",
  "Following's favorites": "关注的人收藏的中继",
  Recommended: "推荐",
  Discover: "发现",
  "Trending notes": "热门笔记",
  "Trending notes are fetched from the trending relay": "热门笔记来自热门中继",
  "Search relays": "搜索中继",
  "Local filter": "本地筛选",
  "Relay search": "中继搜索",
  "Search notes and people": "搜索笔记和用户",
  "Notes": "笔记",
  People: "用户",
  Profiles: "用户",
  "Relay feed": "中继信息流",
  "Feed type": "信息流类型",
  "Switch feed": "切换信息流",
  "Personal feeds": "个人信息流",
  "Choose a feed": "选择信息流",
  "Relay feeds are read from these relays": "中继信息流从这些中继读取",
  "connections": "连接",
  Connected: "已连接",
  Connecting: "连接中…",
  Reconnecting: "重连中…",
  Disconnected: "已断开",
  Unreachable: "无法连接",
  "Read": "读取",
  "Write": "写入",
  "Read & write": "读写",
  "Muted words": "屏蔽词",
  "Include replies in the feed": "在信息流中包含回复",
  "Live updates": "实时更新",
  "Reset settings": "重置设置",
  "Reset": "重置",
  "Save": "保存",
  "Cancel": "取消",
  "Delete": "删除",
  "Rename": "重命名",
  "Create": "创建",
  "Close": "关闭",
  "Loading…": "加载中…",
  "Loading relays…": "正在连接中继…",
  "Fetching relay information…": "正在获取中继信息…",
  "Review": "评价",
  "Stars": "评分",
  "Read from this relay": "从此中继读取",
  "Add to feed": "添加到信息流",
  "Streaming": "读取此中继",
  Follow: "关注",
  Following2: "已关注",
  Unfollow: "取消关注",
  "Followers": "关注者",
  "Follows you": "关注了你",
  "joined": "加入于",
  "No metadata": "没有资料",
  "Edit profile": "编辑资料",
  "Open relay": "打开中继",
  "Open profile": "打开用户",
  Profile: "个人主页",
  "Your profile": "你的主页",
  Muted: "已静音",
  Replies: "回复",
  Articles: "文章",
  "Copy npub": "复制 npub",
  "Display name": "昵称",
  Name: "名称",
  About: "简介",
  "Avatar URL": "头像链接",
  "Banner URL": "横幅链接",
  "Lightning address": "闪电地址",
  Website: "网站",
  Reload: "重新加载",
  "No notes found": "没有找到笔记",
  "Profile saved": "资料已保存",
  "Published as a kind 0 metadata event to your relays.": "以 kind 0 元数据事件发布到你的中继。",
  "Filter this profile's notes": "筛选此用户的笔记",
  "with media": "含媒体",
  "articles": "文章",
  "New Note": "新笔记",
  Drafts: "草稿",
  "Saved drafts": "已保存的草稿",
  "Delete draft": "删除草稿",
  "No drafts yet — notes you close without posting are saved here.": "还没有草稿——关闭但未发布的笔记会保存在这里。",
  "Composer mode": "编辑模式",
  Edit: "编辑",
  Preview: "预览",
  "Write a note": "写一条笔记",
  "Next note in the thread…": "话题串中的下一条笔记…",
  "Thread note": "话题串笔记",
  "Remove note": "移除笔记",
  "Nothing to preview yet — write your note first.": "暂无可预览的内容——请先写下笔记。",
  Thread: "话题串",
  notes: "条笔记",
  Protected: "受保护",
  "Publish as a NIP-70 protected note": "以 NIP-70 受保护笔记发布",
  "What is a protected note?": "什么是受保护笔记？",
  "Choose which relays receive this note": "选择接收此笔记的中继",
  "Publish to relays": "发布到中继",
  "Optimal relays": "最佳中继",
  "1 relay": "1 个中继",
  relays: "个中继",
  "Pick relays": "选择中继",
  "Add a relay first.": "请先添加一个中继。",
  "Content warning": "内容警告",
  "e.g. spoilers": "例如：剧透",
  "Protected note (NIP-70)": "受保护笔记（NIP-70）",
  "Publish to optimal relays": "发布到最佳中继",
  "Add media": "添加媒体",
  "Media URL": "媒体链接",
  Insert: "插入",
  "Choose file…": "选择文件…",
  "Add emoji": "添加表情",
  Emoji: "表情",
  "Add a note to the thread": "在话题串中新增笔记",
  "Insert a bulleted list": "插入项目符号列表",
  "first point": "第一点",
  "second point": "第二点",
  "Post settings": "发布设置",
  Mentions: "提及",
  "Search people you follow": "搜索你关注的人",
  "Follow people to mention them here.": "关注一些人后即可在此提及。",
  Post: "发布",
  "Posting…": "发布中…",
  "Media uploads are not configured in this build — paste a hosted image, video or audio URL instead.":
    "此版本未配置媒体上传——请粘贴图片、视频或音频的链接。",
  'Protected notes carry a NIP-70 "-" tag. Relays must only share them with you and the accounts you mention, and require NIP-42 authentication before serving them.':
    "受保护笔记带有 NIP-70 的 “-” 标签：中继只能与你以及你提及的账户分享，并在提供该笔记前要求 NIP-42 认证。",
}
